// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"85f9f916","314":"a92bb21f","478":"0b10cb04","759":"5896cd9c","799":"fe92088a","828":"cd334a81","845":"11ab693c"}[chunkId] + ".chunk.js";
};